import { render } from "./RegionDashboardsRatingCards.vue?vue&type=template&id=7beab106&scoped=true&ts=true"
import script from "./RegionDashboardsRatingCards.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsRatingCards.vue?vue&type=script&lang=ts"

import "./RegionDashboardsRatingCards.vue?vue&type=style&index=0&id=7beab106&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7beab106"]])

export default __exports__